module.exports = __webpack_public_path__ + "static/media/test13_1.0a98e377.png";